<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'repository.categories.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'repository.transportTypes.list.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-dictionary-edit *ngIf="isCreationMode && !editedId" [transportTypes]="transportTypes"
        [urgencyLevels]="urgencyLevels" [lots]="lots" (editFinished)="onEditFinished()"></app-dictionary-edit>
    </section>
    <section class="datatable-container">
      <div>
        <h3>Type de transport</h3>
        <app-dictionary-values-list [dictionary]="'transportTypes'"
          [data]="transportTypes"></app-dictionary-values-list>
      </div>

      <div>
        <h3>Niveau d'urgence</h3>
        <app-dictionary-values-list [dictionary]="'urgencyLevels'" [data]="urgencyLevels"></app-dictionary-values-list>
      </div>

      <div>
        <h3>Lots / Objets du transport</h3>
        <app-dictionary-values-list [dictionary]="'lots'" [data]="lots"></app-dictionary-values-list>
      </div>

    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>